const screenReaderAlertTemplate = ({screenReaderAlertText}) => `<div class="sr-only alert-only" role="alert">${screenReaderAlertText}</div>')`;

export default screenReaderAlertTemplate;
